
$(document).ready(function ($) {

	var arrowLeft = '<svg viewBox="0 0 90 90" width="90" height="90" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg"><g><path d="M45 89.8A44.9 44.9 0 1 1 45 0a44.9 44.9 0 0 1 0 89.8zm0-86.6a41.8 41.8 0 1 0 0 83.7 41.8 41.8 0 0 0 0-83.7z"/><path d="M50.1 60.7c-.3 0-.7-.1-1-.4L34.2 45.4c-.6-.6-.6-1.5 0-2.1l14.9-15a1.5 1.5 0 1 1 2.1 2.2L37.4 44.3l13.8 13.8a1.5 1.5 0 0 1-1 2.6z"/></g></svg>';
	var arrowRight = '<svg viewBox="0 0 90 90" width="90" height="90" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg"><g><path d="M44.98.15c24.72 0 44.83 20.11 44.83 44.83s-20.1 44.83-44.83 44.83S.15 69.7.15 44.98 20.26.15 44.98.15zm0 86.62a41.84 41.84 0 0 0 41.8-41.79c0-23.04-18.76-41.79-41.8-41.79S3.2 21.94 3.2 44.98a41.84 41.84 0 0 0 41.8 41.79z"/><path d="M39.82 29.24c.39 0 .78.15 1.07.45l14.85 14.86c.6.6.6 1.56 0 2.15L40.9 61.57a1.52 1.52 0 1 1-2.15-2.16l13.78-13.78-13.78-13.8a1.52 1.52 0 0 1 1.08-2.59z"/></g></svg>';

    (function () {
        var $hotelSlider = null;
        $hotelSlider = $('.entry-home-gallery').find('.inner-slider');
        if ($hotelSlider) {
            $hotelSlider.slick({
                arrows: true,
                dots: true,
                fade: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                centerMode: true,
                variableWidth: true,
                prevArrow: '<a class="slick-prev">' + arrowLeft + '</a>',
                nextArrow: '<a class="slick-next">' + arrowRight + '</a>',
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            arrows: false
                        }
                    }
                ]
            });
        }

    })();

});

$(document).ready( function() {
	const $heroVideo = $('#hero-video');
	if ( $heroVideo.length > 0) {
		const mediaVideo = $heroVideo.get(0);
		const $btnMute = $('.js-video-controls .mute-control');
		const $btnPause = $('.js-video-controls .pause-control');

		if ( document.getElementById("hero-embed").classList.contains("mobile-video") ) {
			$btnPause.find('.icon').removeClass('stop');
		}

		$btnPause.on('click', ev => {
			if (mediaVideo.paused) {
				mediaVideo.play();
				$btnPause.find('.icon').removeClass('stop');
			} else {
				mediaVideo.pause();
				$btnPause.find('.icon').addClass('stop');
			}
		});
		$btnMute.on('click', ev => {
			if (mediaVideo.muted) {
				$btnMute.find('.icon').addClass('stop');
			} else {
				$btnMute.find('.icon').removeClass('stop');
			}
			mediaVideo.muted = !mediaVideo.muted;
		});
	}
});

document.addEventListener('DOMContentLoaded', function() {
	const presentButton = document.getElementById('present');
	const menuPdfs = document.getElementById('menu-pdfs');

	presentButton.addEventListener('click', function(event) {
		event.stopPropagation();
		menuPdfs.classList.toggle('d-none');
	});

	document.addEventListener('click', function(event) {
		if (!menuPdfs.classList.contains('d-none') && !menuPdfs.contains(event.target) && event.target !== presentButton) {
			menuPdfs.classList.add('d-none');
		}
	});
});
